// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ImageWrapper_wrapper__2sKmD","inactive":"ImageWrapper_inactive__hjvjx","active":"ImageWrapper_active__1JhmD","fadeIn":"ImageWrapper_fadeIn__2EZVu"};